import { SelectionModel } from '@angular/cdk/collections'
import { HttpClient, HttpHeaders } from '@angular/common/http'
import {
  AfterViewInit,
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewChild
} from '@angular/core'
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms'
import { MatAutocompleteTrigger } from '@angular/material/autocomplete'
import { MatBottomSheet } from '@angular/material/bottom-sheet'
import { MatDialog } from '@angular/material/dialog'
import { MatPaginator } from '@angular/material/paginator'
import { MatSort } from '@angular/material/sort'
import { MatTableDataSource } from '@angular/material/table'
import { NavigationEnd, Router } from '@angular/router'
import { NgxSpinnerService } from 'ngx-spinner'
import { fromEvent, merge, Observable, of as observableOf, Subject } from 'rxjs'
import * as XLSX from 'xlsx'

import {
  catchError,
  debounceTime,
  filter,
  map,
  startWith,
  switchMap
} from 'rxjs/operators'

import {
  Lector,
  RequestProductsAdd,
  ResponseConfirmProductsReceiving,
  ResponseConfirmProductsReceivingAdd,
  ResponseConfirmProductsReceivingConfin,
  ResponseInventoryAvailable,
  ResponseReceivingChanges,
  ResponseReceivingTable,
  ResponseReceivingTableNew,
  ResponseUSer,
  ResponseViewInventoryMove,
  ResponseViewProductsReceiving
} from 'src/app/_models'
import {
  AuthenticationService,
  ReceivingEditTableProductService,
  SearchTableReceivingService,
  ViewInventotyAvailableService,
  ViewReceivingMoveInventoryService,
  ViewReceivingProductsService
} from 'src/app/_services'
import { ViewConfirmProductsService } from 'src/app/_services/view-confirm-products.service'
import { environment } from 'src/environments/environment'
import Swal from 'sweetalert2'
import { AddProductsModalComponent } from '../modal/add-products-modal/add-products-modal.component'
import { CodeBarScannerComponent } from '../modal/code-bar-scanner/code-bar-scanner.component'
import { ConfirmProductReceivingComponent } from '../modal/confirm-product-receiving/confirm-product-receiving.component'
import { EditProductReceivingComponent } from '../modal/edit-product-receiving/edit-product-receiving.component'
import { EditProductsItemsComponent } from '../modal/edit-products-items/edit-products-items.component'
import { MasivoConfimacionReceivingComponent } from '../modal/masivo-confimacion-receiving/masivo-confimacion-receiving.component'
import { UpdateMoveInventoryComponent } from '../modal/update-move-inventory/update-move-inventory.component'
import { OpcionesComponent } from '../pdf/opciones/opciones.component'
import { EditPalletCustomersComponent } from '../modal/edit-pallet-customers/edit-pallet-customers.component'
import { ReceivingExportProdutsToShippingComponent } from '../modal/receiving-export-produts-to-shipping/receiving-export-produts-to-shipping.component'
import { MatSelect } from '@angular/material/select'
import {
  NgxFileDropEntry,
  FileSystemFileEntry,
  FileSystemDirectoryEntry
} from 'ngx-file-drop'

export interface UserData {
  id: string
  name: string
  progress: string
  color: string
}
export interface UserData2 {
  id: string
  name: string
  progress: string
  color: string
}
export interface User {
  name: string
}
export interface ProduuctsSelect {
  id: number
  ItemNumber: string
  ItemDescription: string
  ItemDescription1: string
  UnitMeasureType: number
}
@Component({
  selector: 'app-receive-pallents',
  templateUrl: './receive-pallents.component.html',
  styleUrls: ['./receive-pallents.component.css']
})
export class ReceivePallentsComponent
  implements OnInit, AfterViewInit, OnDestroy
{
  DatosProductsAdd: RequestProductsAdd
  summaryProducts = []
  isLoadingResults2 = true
  isRateLimitReached2 = false
  viewproducts = false
  InfoCompany = []
  labelInvoiceHeaderButton = 'Save'
  FormInvoiceHeader: FormGroup
  AllChargesAdded = true
  IdEditNewChanges = 0
  descuentoCharges = 0
  IdChargesDescuento = null
  selectInvoice: any
  resultsLengthProduct = 0
  invoiceList = []
  dataSourceChangesReceivig: MatTableDataSource<ResponseReceivingChanges>
  arrayDatosChangeReceivinng: ResponseReceivingChanges[]
  arrayDatosChangeReceivinng2 = []
  @ViewChild('TableSearchChangeReceivinngPaginator')
  ChangeReceivinngpaginatorSearch: MatPaginator
  @ViewChild('TableSearchChangeReceivinngSort')
  ChangeReceivinngsortSearch: MatSort
  displayedColumnsSearchdataSourceChangesReceivig: string[] = [
    'Id',
    'tblReceivingID',
    'tblCompanyChargesID',
    'tblInvoiceListDescription',
    'ChargeDescription',
    'UnitPrice',
    'Quantity',
    'Total',
    'QBIntegrated'
  ]
  editItemsReceive = true
  actives = 'Receive products'
  //#region variables
  productosTab = true
  productosChangeTab = true
  MoveInventoryTable = false
  InventarioTable = false
  mySubscription: any
  currentUser: ResponseUSer
  tab1 = true
  myControl = new FormControl()
  options: ProduuctsSelect[] = []
  options2: ProduuctsSelect[] = []
  filteredOptions: Observable<ProduuctsSelect[]>
  stateCtrl = new FormControl()
  datosMove: ResponseViewInventoryMove
  idConfirmClickReferechTable: Number
  idjsonMoveInventoryLocation: any
  idmoveInventoryTable: Number
  ViewProductTab = true
  confirmarTab = true
  DatosSelectProduct: any
  dtTrigger: Subject<any> = new Subject<any>()
  dtoptions: any
  Registro: any
  piezas: number
  IdEditar: Number
  buttonEditaLabel: String = 'Save'
  buttonEdita = false
  etaDate: Date
  FormReceivingChanges: FormGroup
  FormReceivingProducts: FormGroup
  FormReceivingProductsAdd: FormGroup
  custome: any
  viewEdit = false
  formGroupInventory: FormGroup
  inventorySearch: any
  PlaceOrderCustomer = []
  ArrayProdutsItems = []
  ArrayLocations = []
  From: any
  To: any
  indexTabs = new FormControl(3)
  indexTabs2 = new FormControl(0)
  displayedColumnsSearch: string[] = [
    'ID',
    'idReference',
    'Company_Name',
    'tblcustomerID',
    'ReferenceNumber',
    'PONumber',
    'ReceivedDate',

    'ETA',
    'status_type',
    'ContainerNumber',
    'CapacityType',
    'BOLNumber',

    'charges'
    // ,
    // 'Billed',
    // 'AllChargesAdded',
    // 'HandlingCharge',

    // 'ShortTermStorage'
  ]
  SearchDatabase: SearchTableReceivingService | null
  InventoryDatabase: ViewInventotyAvailableService | null
  ispallet = true
  dataInventory: ResponseInventoryAvailable[] = []
  data: ResponseReceivingTableNew[] = []
  dataSourceSearch: MatTableDataSource<ResponseReceivingTableNew>
  @ViewChild('TableSearchPaginator') paginatorSearch: MatPaginator
  @ViewChild('TableSearchSort') sortSearch: MatSort
  resultsLength = 0
  isLoadingResults = true
  isRateLimitReached = false
  searchTable = false

  value = ''
  value2 = ''
  checked = false
  selected = 'option2'
  selected2 = 'option2'
  selected3: any

  displayedColumns: string[] = [
    'rowNumber',
    'ItemNumber',
    'Description',
    'Received',
    'Pending',
    'Shipped',
    'Available',
    'Cartons',
    'Pallets'
  ]
  dataSource: MatTableDataSource<ResponseInventoryAvailable>

  @ViewChild('TableReceivePaginator') paginator: MatPaginator
  @ViewChild('TableReceiveSort') sort: MatSort

  displayedColumnsMove: string[] = [
    'id',
    'ItemNumber',
    'Description',
    'LotNumber',
    'Location',
    'Quantity'
  ]
  dataSourceMove: MatTableDataSource<ResponseViewInventoryMove>
  @ViewChild('TableTwoPaginator') paginatorMove: MatPaginator
  @ViewChild('TableTwoSort') sortMove: MatSort

  //tabla confirm products receibing

  displayedColumnsConfirm: string[] = [
    'select',
    'id',
    'ItemNumber',
    'ItemDescription',

    'LotNumber',
    'StatedQuantity',
    'Location',
    'LocationID',
    'SerialNumber',
    'Notas',
    'PalletAmount',
    'ItemValue',
    'productID'
  ]
  ConfirmDatabase: ViewConfirmProductsService | null
  dataConfirm: MatTableDataSource<ResponseConfirmProductsReceivingConfin>
  dataArrary: ResponseConfirmProductsReceivingConfin[] = []
  CargaMasivaConfirmacion: ResponseConfirmProductsReceivingConfin[]
  resultsLengthConfirm = 0
  isLoadingResultsConfirm = true
  isRateLimitReachedConfirm = false

  MoveInventory: ViewReceivingMoveInventoryService | null
  dataMoveInventory: ResponseViewInventoryMove[] = []

  displayedColumnsReceivingEditaTable: string[] = [
    'id',
    'ItemNumber',
    'ItemDescription',

    'LotNumber',
    'StatedQuantity',
    'Location',
    'LocationID',
    'SerialNumber',
    'ExpirationDate',

    'Note',
    'weight_pllets',
    'type_pallets'
  ]
  ReceivingEditatableServices: ReceivingEditTableProductService | null
  dataReceivingEdit: MatTableDataSource<ResponseConfirmProductsReceivingAdd>
  dataArrayReceivingEdit: ResponseConfirmProductsReceivingAdd[] = []
  @ViewChild('locations') locationsSelect: MatSelect
  //Receiving View products
  ReceivingServicesViewProducts: ViewReceivingProductsService | null
  dataServicesViewProducts: MatTableDataSource<ResponseViewProductsReceiving>
  dataArrayServicesViewProducts: ResponseViewProductsReceiving[] = []
  ColumnsServicesViewProducts: string[] = [
    'id',
    'tblReceivingProductsID',
    'tblProductID',
    'LotNumber',
    'StatedQuantity',
    'ActualQuantity',
    'Discrepancy',
    'AvailableQuantity',
    'tblLocationID',
    'ExpirationDate',
    'SerialNumber',
    'Completed',
    'Notes',
    'DateCreated',
    'ItemNumber'
  ]
  @ViewChild('TableViewReceivingProductsPaginator')
  TableViewReceivingProductsPaginator: MatPaginator
  @ViewChild('TableViewReceivingProductsSort')
  TableViewReceivingProductsSort: MatSort

  @ViewChild('receivingeditPaginator') receivingeditPaginator: MatPaginator
  @ViewChild('receivingeditSort') receivingeditSort: MatSort

  @ViewChild('paginatorConfirm') paginatorConfirm: MatPaginator
  @ViewChild('sortConfirm') sortConfirm: MatSort
  Toast = Swal.mixin({
    toast: true,
    position: 'center',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: false,
    background: ' #ffffff29',

    padding: '80px 20px 80px',

    didOpen: toast => {
      Swal.showLoading()
      toast.addEventListener('mouseenter', Swal.stopTimer)
      toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
  })
  datosLector: Lector
  datosinicio = ''
  checked2 = false
  datosEditAddProduct: ResponseConfirmProductsReceiving
  idrefesttable: any
  @ViewChild('auto') autocomplete: MatAutocompleteTrigger
  DefaultFechaFin = new FormControl(new Date(new Date().getTime() + 3888000000))
  DefaultFechaInicio = new FormControl(
    new Date(new Date().getTime() - 20 * 24 * 60 * 60 * 1000)
  )
  selection = new SelectionModel<ResponseConfirmProductsReceivingConfin>(
    true,
    []
  )
  btnRemoveInventory = false  
  //#endregion

  constructor(
    private _httpClient: HttpClient,
    private authenticationService: AuthenticationService,
    private formbuider: FormBuilder,
    public dialog: MatDialog,
    private router: Router,
    private spinner: NgxSpinnerService,
    private _bottomSheet: MatBottomSheet
  ) {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(events => {
        this.authenticationService.currentUser.subscribe(
          x => (this.currentUser = x)
        )
      })
    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false
    }
    this.mySubscription = this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        console.log('ddddd')
        // Trick the Router into believing it's last link wasn't previously loaded
        this.router.navigated = true
      }
    })
    this.CargaMasivaConfirmacion = []
    this.ArrayProdutsItems = []
    this.ArrayLocations = []
    this.invoiceList = []
    this.InfoCompany = []
    this.arrayDatosChangeReceivinng2 = []
    this.summaryProducts = []
    this.PlaceOrderCustomer = []
    this.arrayDatosChangeReceivinng = []
    // Assign the data to the data source for the table to render
    this.dataSource = new MatTableDataSource(this.dataInventory)
    this.dataSourceMove = new MatTableDataSource(this.dataMoveInventory)
    this.dataSourceSearch = new MatTableDataSource(this.data)
    this.dataConfirm = new MatTableDataSource(this.dataArrary)
    //this.dataReceivingEdit=new MatTableDataSource(this.dataArrayReceivingEdit)
    this.From = this.DefaultFechaInicio.value
    this.To = this.DefaultFechaFin.value

    this.AllChargesAdded = false
    //this.FormReceivingProducts.controls.AllChargesAdded.setValue(false);
  }
  ngOnDestroy(): void {
    if (this.mySubscription) {
      this.mySubscription.unsubscribe()
    }
    var element = document.getElementById('SubMenu')
    element.style.display = 'none'

    localStorage.setItem('header', '0')
  }
  ngOnInit(): void {
    this.FormReceivingProducts = this.formbuider.group({
      referencia: [''],
      customer: [''],
      eta: [''],
      receivingdate: [''],
      Carrier: [''],
      bol: [''],
      po: [''],
      misc: [''],
      container: [''],
      seal: [''],
      door: [''],
      capacity: [''],
      pallets: [1],
      notes: [' '],
      palletsx: [''],
      Billed: [''],
      HandlingCharge: [''],
      ShortTermStorage: [''],
      status: [''],
      Completed: [0]
    })
    this.FormReceivingProductsAdd = this.formbuider.group({
      product: ['', this.myControl],
      location: ['', Validators.required],
      palletsx: [1],
      pickerProductEter: [''],
      Quantity: ['', Validators.required],
      Lot: [''],
      Serial: [''],
      Note: [''],
      type: ['PLTS'],
      weight: ['']
    })
    this.FormReceivingChanges = this.formbuider.group({
      invoiceListSelect: [''],
      priceUnit: [''],
      QuantityChanges: [''],
      TotalChangesR: ['']
    })
    /*  this.formGroupInventory=this._fb.group({
		searchInventory:[""]
	  }); */
    this.FormInvoiceHeader = this.formbuider.group({
      tipo: [0],
      id_order: [''],
      type_order: ['Receiving'],
      fromname: [''],
      fromstreet: [''],
      toname: [''],
      tostreet: [''],
      billname: [''],
      billstreet: [''],
      invoicenumber: [''],
      payterm: [''],
      customerid: [''],
      referencesnumber: [''],
      dateinvoice: [''],
      totalamount: [''],
      noteinvoice: ['']
    })
    this.FormReceivingProductsAdd.controls.palletsx.setValue(1)
    this.FormReceivingProductsAdd.controls.Quantity.setValue(1)
    this.FormReceivingProducts.controls.Billed.setValue(false)
    this.FormReceivingProducts.controls.HandlingCharge.setValue(false)
    this.FormReceivingProducts.controls.ShortTermStorage.setValue(false)
    this.OnSelectCostumer()
    this.OnSelectLocations('')
    this.OnChangeInvoiceList()
    try {
      this.dataSourceChangesReceivig = new MatTableDataSource(
        this.arrayDatosChangeReceivinng
      )
      this.dataSourceChangesReceivig.sort = this.ChangeReceivinngsortSearch
      this.dataSourceChangesReceivig.paginator =
        this.ChangeReceivinngpaginatorSearch
    } catch (error) {}

    try {
      if (this.authenticationService.currentUserValue.company == 'LDT20') {
        this.FormReceivingProducts.controls.referencia.setValue('')
        if(this.authenticationService.currentUserValue.useremail==='cgaxiola@linedrivetrucking.com'){

          this.btnRemoveInventory = true  
        }else if(this.authenticationService.currentUserValue.useremail==='rsanchez@linedrivetrucking.com'){

          this.btnRemoveInventory = true  
        }else if(this.authenticationService.currentUserValue.useremail==='LDT20@3plfreightsoftware.com'){

          this.btnRemoveInventory = true  
        }
      } else {
        this.FormReceivingProducts.controls.referencia.setValue(
          'REF#-' + String(this.makeid(7))
        )
      }
    } catch (error) {}

    $(document).on('keypress', '.TabOnEnter', function (e) {
      //Only do something when the user presses enter
      if (e.keyCode == 13) {
        var nextElement = $('[tabindex="' + (this.tabIndex + 1) + '"]')
        console.log(this, nextElement)
        if (nextElement.length) nextElement.focus()
        else $('[tabindex="1"]').focus()
      }
    })

    $(document).on('keypress', '.TabOnEnterReceiving', function (e) {
      //Only do something when the user presses enter
      if (e.keyCode == 13) {
        var nextElement = $('[tabindex="' + (this.tabIndex + 1) + '"]')
        console.log(this, nextElement)
        if (nextElement.length) {
          nextElement.focus()

          try {
            nextElement.select()
          } catch (error) {}
        } else {
          $('[tabindex="1"]').focus()
        }
      }
    })
    $(document).on('keypress', '.enterProductAdd', function (e) {
      //Only do something when the user presses enter
      if (e.keyCode == 13) {
        var nextElement = $('[tabindex="' + (this.tabIndex + 1) + '"]')
        console.log(this, nextElement)
        if (nextElement.length) {
          nextElement.focus()

          try {
            nextElement.select()
          } catch (error) {}
        } else {
          // $('[tabindex="18"]').focus()
        }
      }
    })
  }
  OnChangeLoader() {
    this.spinner.show()

    setTimeout(() => {
      /** spinner ends after 5 seconds */
      this.spinner.hide()
    }, 3000)
  }

  onKeydown(e) {
    console.log(e, 'teclado')
    this.options = this.options2
    this.autocomplete.openPanel()
    this.datosinicio = ''
    this.filteredOptions = this.myControl.valueChanges.pipe(
      startWith(''),
      map(value => (typeof value === 'string' ? value : value)),
      map(name => (name ? this._filter(name) : this.options.slice()))
    )
  }
  OnChangeArrayItems() {}
  displayFn(user: ProduuctsSelect): string {
    return user && user.ItemNumber ? user.ItemNumber : user.ItemDescription
  }

  private _filter(name: string): ProduuctsSelect[] {
    const filterValue = String(name).toLowerCase()

    return this.options.filter(option =>
      option.ItemNumber.toLowerCase().indexOf(filterValue) === 0
        ? option
        : option.ItemDescription.toLowerCase().indexOf(filterValue) === 0
    )
  }
  ngAfterViewInit() {
    const main = <HTMLInputElement>document.getElementById('SubMenu')

    fromEvent(main, 'mouseenter')
      .pipe(
        switchMap(event => {
          console.log('show')
          main.style.display = 'block'
          return fromEvent(main, 'mouseleave').pipe(debounceTime(500))
        })
      )
      .subscribe(val => {
        console.log('hide')
        main.style.display = 'none'
      })
    this.dataSource.sort = this.sort
    this.dataSource.paginator = this.paginator

    try {
      for (let index = 0; index < 10; index++) {
        var etiquet = 'mat-tab-label-' + index + '-1'
        var etiquet2 = 'mat-tab-label-' + index + '-2'
        try {
          document.getElementById(etiquet).style.display = 'none'
          document.getElementById(etiquet2).style.display = 'none'
        } catch (error) {}
      }
      this.FormReceivingProducts.controls.pallets.setValue(1)
      this.FormReceivingProducts.controls.eta.setValue(
        new Date(new Date().setHours(0, 0, 0, 0))
      )

      this.FormReceivingProducts.controls.receivingdate.setValue(
        new Date(new Date().setHours(0, 0, 0, 0))
      )
    } catch (error) {}
  }

  OnChangeSearch() {
    var estado = ''
    if (this.checked) {
      estado = '1'
    } else {
      estado = '0'
    }
    if (
      this.From == '' ||
      this.From == null ||
      this.To == '' ||
      this.To == null
    ) {
      Swal.fire('se requieren los campos de fecha')
      return
    }
    this.searchTable = true
    this.SearchDatabase = new SearchTableReceivingService(this._httpClient)

    merge()
      .pipe(
        startWith({}),
        switchMap(() => {
          this.spinner.show()
          this.isLoadingResults = true
          return this.SearchDatabase!.getRepoIssuesNew(
            this.value,
            estado,
            this.From,
            this.To
          )
        }),
        map(data => {
          this.spinner.hide()
          // Flip flag to show that loading has finished.
          this.isLoadingResults = false
          this.isRateLimitReached = false
          this.resultsLength = data.length

          return data
        }),
        catchError(() => {
          this.spinner.hide()
          this.isLoadingResults = false
          // Catch if the GitHub API has reached its rate limit. Return empty data.
          this.isRateLimitReached = true
          return observableOf([])
        })
      )
      .subscribe(datas => {
        this.data = datas
        this.dataSourceSearch = new MatTableDataSource(this.data)
        this.dataSourceSearch.sort = this.sortSearch
        this.dataSourceSearch.paginator = this.paginatorSearch
      })
  }
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value
    this.dataSource.filter = filterValue.trim().toLowerCase()

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage()
    }
  }
  applyFilterChangesReceivig(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value
    this.dataSourceChangesReceivig.filter = filterValue.trim().toLowerCase()

    if (this.dataSourceChangesReceivig.paginator) {
      this.dataSourceChangesReceivig.paginator.firstPage()
    }
  }
  applyFilter2(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value
    this.dataReceivingEdit.filter = filterValue.trim().toLowerCase()

    if (this.dataReceivingEdit.paginator) {
      this.dataReceivingEdit.paginator.firstPage()
    }
  }
  applyFilterMove(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value
    this.dataSourceMove.filter = filterValue.trim().toLowerCase()

    if (this.dataSourceMove.paginator) {
      this.dataSourceMove.paginator.firstPage()
    }
  }
  applyFilterSearch(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value
    this.dataSourceSearch.filter = filterValue.trim().toLowerCase()

    if (this.dataSourceSearch.paginator) {
      this.dataSourceSearch.paginator.firstPage()
    }
  }

  applyFilterViewProducts(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value
    this.dataServicesViewProducts.filter = filterValue.trim().toLowerCase()

    if (this.dataServicesViewProducts.paginator) {
      this.dataServicesViewProducts.paginator.firstPage()
    }
  }
  //EDICION DE RECEIVING PRODUCTS

  Oneditar(data: ResponseReceivingTableNew) {
    console.log(data, 'dataeditar')
    this.OnCancelarEdicion()

    setTimeout(() => {
      this.spinner.show()
      this.Registro = data.ID
      this.onSelectStatusReceivingProducts()
      this.OnChangeReceivingTable2(this.Registro)
      this.onSelectSummaryProducts()
      this.spinner.hide()
      this.spinner.show()
      this.tab1 = false
      this.IdEditar = data.ID
      this.buttonEditaLabel = 'Save'
      this.buttonEdita = true
      var json = JSON.parse(localStorage.getItem('currentUser')) //json con datos de usuario

      var Request = {}
      Request['receivingId'] = data.ID

      this._httpClient
        .post<any>(
          `${environment.apiUrl}/Receive/ReceivingInformacionProductsEdit`,
          Request,
          {
            headers: new HttpHeaders({
              'Access-Control-Allow-Origin': '*',
              'Access-Control-Allow-Headers': '*',
              'Access-Control-Allow-Methods': '*',
              Authorization: 'Bearer ' + json.token
            })
          }
        )
        .subscribe((response: any) => {
          this.spinner.show()
          console.log(response)

          try {
            this.FormReceivingProducts.controls.referencia.setValue(
              String(data.ReferenceNumber)
            )
          } catch (error) {}
          //this.FormReceivingProducts.controls.referencia.disable();
          try {
            this.FormReceivingProducts.controls.customer.setValue(
              Number(response[0].tblCustomerID)
            )
          } catch (error) {}
          this.FormReceivingProducts.controls.customer.disable()
          try {
            console.log(response[0].ETA)

            this.FormReceivingProducts.controls.eta.setValue(
              new Date(new Date(response[0].ETA + ' 13:00:00'))
            )
          } catch (error) {}

          try {
            this.FormReceivingProducts.controls.receivingdate.setValue(
              new Date(new Date(response[0].ReceivedDate + ' 13:00:00'))
            )
          } catch (error) {}

          try {
            this.FormReceivingProducts.controls.Carrier.setValue(
              response[0].CarrierName
            )
          } catch (error) {}

          try {
            this.FormReceivingProducts.controls.bol.setValue(
              response[0].BOLNumber
            )
          } catch (error) {}

          try {
            this.FormReceivingProducts.controls.po.setValue(
              response[0].PONumber
            )
          } catch (error) {}

          try {
            this.FormReceivingProducts.controls.misc.setValue(
              response[0].MiscText
            )
          } catch (error) {}
          try {
            this.FormReceivingProducts.controls.container.setValue(
              response[0].ContainerNumber
            )
          } catch (error) {}

          try {
            this.FormReceivingProducts.controls.seal.setValue(
              response[0].SealNumber
            )
          } catch (error) {}

          try {
            this.FormReceivingProducts.controls.door.setValue(
              response[0].DoorNumber
            )
          } catch (error) {}
          try {
            this.FormReceivingProducts.controls.capacity.setValue(
              response[0].CapacityType
            )
          } catch (error) {}
          try {
            this.FormReceivingProducts.controls.pallets.setValue(
              response[0].TotalPallets || '0'
            )
          } catch (error) {}
          try {
            this.FormReceivingProducts.controls.notes.setValue(
              response[0].Notes
            )
          } catch (error) {}
          try {
            this.FormReceivingProducts.controls.Billed.setValue(
              Boolean(Number(response[0].Billed))
            )
          } catch (error) {}
          try {
            this.AllChargesAdded = Boolean(Number(response[0].AllChargesAdded))
          } catch (error) {}

          // this.FormReceivingProducts.controls.AllChargesAdded.setValue(
          // Boolean(Number(response[0].AllChargesAdded))
          //);
          try {
            this.FormReceivingProducts.controls.HandlingCharge.setValue(
              Boolean(Number(response[0].HandlingCharge))
            )
          } catch (error) {}
          try {
            this.FormReceivingProducts.controls.ShortTermStorage.setValue(
              Boolean(Number(response[0].ShortTermStorage))
            )
          } catch (error) {}
          try {
            this.FormReceivingProductsAdd.controls.palletsx.setValue(1)
          } catch (error) {}

          try {
            this.FormReceivingProductsAdd.controls.Quantity.setValue(1)
          } catch (error) {}
          try {
            this.FormReceivingProducts.controls.Completed.setValue(
              Number(data.Completed)
            )
          } catch (error) {}
          try {
            this.editItemsReceive = Boolean(Number(data.Completed))
          } catch (error) {}
          //this.FormReceivingProductsAdd.controls.Quantity.disable();
          setTimeout(() => {
            this.spinner.show()
            this.OnReceivinTebleEdit(data)
            this.indexTabs = new FormControl(0)
            this.indexTabs2 = new FormControl(0)
            this.OnSelectProductsItems()
            this.spinner.hide()
          }, 1200)
        })
    }, 2100)
  }
  OnCancelarEdicion() {
    this.spinner.show()
    this.Registro = 0
    this.tab1 = true
    this.confirmarTab = true
    this.buttonEditaLabel = 'Save'
    this.buttonEdita = false
    this.viewEdit = false
    this.IdEditar = 0
    try {
      this.dataReceivingEdit = new MatTableDataSource(null)
    } catch (error) {
      console.log(error)
    }

    this.FormReceivingProducts.controls.Completed.setValue(0)
    this.FormReceivingProducts.controls.referencia.enable()
    this.FormReceivingProducts.controls.referencia.setValue('')
    this.FormReceivingProducts.controls.customer.setValue(null)
    this.FormReceivingProducts.controls.customer.enable()
    this.FormReceivingProducts.controls.eta.setValue(
      new Date(new Date().setHours(0, 0, 0, 0))
    )

    this.FormReceivingProducts.controls.receivingdate.setValue(
      new Date(new Date().setHours(0, 0, 0, 0))
    )

    this.FormReceivingProducts.controls.Carrier.setValue('')
    this.FormReceivingProducts.controls.bol.setValue('')
    this.FormReceivingProducts.controls.po.setValue('')
    this.FormReceivingProducts.controls.misc.setValue('')
    this.FormReceivingProducts.controls.container.setValue('')
    this.FormReceivingProducts.controls.seal.setValue('')
    this.FormReceivingProducts.controls.door.setValue('')
    this.FormReceivingProducts.controls.capacity.setValue('0')
    this.FormReceivingProducts.controls.pallets.setValue(1)
    this.FormReceivingProducts.controls.notes.setValue('')
    this.FormReceivingProducts.controls.Billed.setValue(false)
    this.AllChargesAdded = false
    //  this.FormReceivingProducts.controls.AllChargesAdded.setValue(false);
    this.FormReceivingProducts.controls.HandlingCharge.setValue(false)
    this.FormReceivingProducts.controls.ShortTermStorage.setValue(false)
    this.summaryProducts = []
    this.indexTabs = new FormControl(0)
    this.indexTabs2 = new FormControl(0)
    this.productosTab = true
    this.productosChangeTab = true
    this.spinner.hide()
  }
  OnSaveOrUpdate() {
    this.spinner.show()
    //this.OnChangeLoader()
    var Request = {}
    if (this.buttonEdita) {
      Request['tipo'] = Number(this.IdEditar)
      Request['Completed'] = String(
        Number(this.FormReceivingProducts.controls.Completed.value)
      )
    } else {
      Request['tipo'] = 0
      Request['Completed'] = '0'
    }

    Request['tblCompanyID'] = String(
      this.authenticationService.currentUserValue.companyIdWh
    )
    Request['tblCustomerID'] = String(
      this.FormReceivingProducts.controls.customer.value
    )
    Request['ReferenceNumber'] = String(
      this.FormReceivingProducts.controls.referencia.value || '  '
    )
    Request['ETA'] = this.FormReceivingProducts.controls.eta.value
    Request['ReceivedDate'] =
      this.FormReceivingProducts.controls.receivingdate.value
    Request['CarrierName'] = String(
      this.FormReceivingProducts.controls.Carrier.value || ''
    )
    Request['BOLNumber'] = String(this.FormReceivingProducts.controls.bol.value)
    Request['PONumber'] = String(this.FormReceivingProducts.controls.po.value)
    Request['ContainerNumber'] = String(
      this.FormReceivingProducts.controls.container.value
    )
    Request['SealNumber'] = String(
      this.FormReceivingProducts.controls.seal.value
    )
    Request['MiscText'] = String(this.FormReceivingProducts.controls.misc.value)
    Request['CapacityType'] = String(
      this.FormReceivingProducts.controls.capacity.value
    )
    Request['DoorNumber'] = String(
      this.FormReceivingProducts.controls.door.value
    )
    Request['Notes'] = String(this.FormReceivingProducts.controls.notes.value)

    Request['CompletedDate'] = ''
    Request['DateCreated'] = new Date(new Date().setHours(0, 0, 0, 0))
    Request['TotalPallets'] = String(
      this.FormReceivingProducts.controls.pallets.value || 0
    )

    Request['Users'] = String(
      this.authenticationService.currentUserValue.useremail
    )

    Request['Billed'] = Number(this.FormReceivingProducts.controls.Billed.value)
    //this.FormReceivingProducts.controls.AllChargesAdded.value
    Request['AllChargesAdded'] = Number(this.AllChargesAdded)
    Request['HandlingCharge'] = Number(
      this.FormReceivingProducts.controls.HandlingCharge.value
    )
    Request['ShortTermStorage'] = Number(
      this.FormReceivingProducts.controls.ShortTermStorage.value
    )

    var json = JSON.parse(localStorage.getItem('currentUser')) //json con datos de usuario

    this._httpClient
      .post<any>(
        `${environment.apiUrl}/Receive/ReceivingProductsNewEdit`,
        Request,
        {
          headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'Access-Control-Allow-Methods': '*',
            Authorization: 'Bearer ' + json.token
          })
        }
      )
      .subscribe((response: any) => {
        this.spinner.hide()
        console.log(response, 'save')

        try {
          this.spinner.show()
          var ids = String(response.responses)
          var rep = ids
            .replace('receiving-new-', '')
            .replace('receiving-edit-', '')
          this.Registro = Number(rep)
          try {
            this.onInsertStatusReceiving(this.Registro)
          } catch (error) {}
          this.IdEditar = this.Registro
          this.buttonEditaLabel = 'Update'
          this.buttonEdita = true
          this.productosTab = false
          this.productosChangeTab = false
          this.viewEdit = true
          this.tab1 = false
          this.indexTabs2 = new FormControl(1)
          this.OnSelectProductsItems()
          this.OnChangeReceivingTable(this.Registro)
          this.FormReceivingProductsAdd.controls.palletsx.setValue(1)

          this.FormReceivingProductsAdd.controls.Quantity.setValue(1)
          // this.FormReceivingProductsAdd.controls.Quantity.disable();
          this.onSelectInvoiceheadr()
          this.spinner.hide()
        } catch (error) {
          this.spinner.hide()
          console.log(error, 'saveError')
          this.Toast.fire({
            icon: 'error',
            title: 'Error'
          })
        }
      })
  }

  onInsertStatusReceiving(OrderId: Number) {
    var Request = {}

    Request['OrderId'] = Number(OrderId)
    Request['status'] = String(this.FormReceivingProducts.controls.status.value)

    var json = JSON.parse(localStorage.getItem('currentUser')) //json con datos de usuario

    this._httpClient
      .post<any>(
        `${environment.apiUrl}/Receive/ReceivingStatusInsert`,
        Request,
        {
          headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'Access-Control-Allow-Methods': '*',
            Authorization: 'Bearer ' + json.token
          })
        }
      )
      .subscribe((response: any) => {
        setTimeout(() => {
          this.onSelectStatusReceivingProducts()
        }, 1000)
      })
  }
  onSelectStatusReceivingProducts() {
    var json = JSON.parse(localStorage.getItem('currentUser')) //json con datos de usuario

    this._httpClient
      .get<any>(
        `${environment.apiUrl}/Receive/ReceivingproductsstatusSelect?OrderId=${this.Registro}`,

        {
          headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'Access-Control-Allow-Methods': '*',
            Authorization: 'Bearer ' + json.token
          })
        }
      )
      .subscribe((response: any) => {
        try {
          this.FormReceivingProducts.controls.status.setValue(
            response[0].status_type
          )
        } catch (error) {
          this.FormReceivingProducts.controls.status.setValue('')
        }
      })
  }

  OnNewOrEditProdutsLsit() {
    if (this.FormReceivingProductsAdd.invalid) {
      return
    }
    this.DatosSelectProduct = this.myControl.value
    var Request = {}
    console.log(this.myControl.value)
    Request['tipo'] = 0
    Request['tblReceivingProductsID'] = Number(this.Registro)
    Request['tblProductID'] = Number(this.DatosSelectProduct.id)
    Request['LotNumber'] =
      String(this.FormReceivingProductsAdd.controls.Lot.value) || ''
    Request['StatedQuantity'] = String(
      this.FormReceivingProductsAdd.controls.Quantity.value || '1'
    )
    Request['ActualQuantity'] = '0'
    Request['Discrepancy'] = '0'
    Request['AvailableQuantity'] = '0'
    Request['tblLocationID'] = String(
      this.FormReceivingProductsAdd.controls.location.value
    )
    Request['ExpirationDate'] =
      this.FormReceivingProductsAdd.controls.pickerProductEter.value || 'sin'
    Request['Notes'] = this.FormReceivingProductsAdd.controls.Note.value
    Request['SerialNumber'] = String(
      this.FormReceivingProductsAdd.controls.Serial.value || ''
    )
    Request['Completed'] = 0
    Request['pallex'] = String(
      this.FormReceivingProductsAdd.controls.palletsx.value || '1'
    )
    Request['CompletedDate'] = new Date()
    Request['typePallets'] = String(
      this.FormReceivingProductsAdd.controls.type.value || 'PLTS'
    )
    Request['weightPallets'] = Number(
      this.FormReceivingProductsAdd.controls.weight.value || 0
    )

    this._httpClient
      .post<any>(
        `${environment.apiUrl}/Receive/ReceivingProdutsItemsNewEditadditional`,
        Request,
        {
          headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'Access-Control-Allow-Methods': '*',
            Authorization:
              'Bearer ' + this.authenticationService.currentUserValue.token
          })
        }
      )
      .subscribe((response: any) => {
        this.FormReceivingProductsAdd.controls.Lot.setValue('')
        this.FormReceivingProductsAdd.controls.Quantity.setValue(1)
        this.FormReceivingProductsAdd.controls.Note.setValue('')
        this.FormReceivingProductsAdd.controls.pickerProductEter.setValue(null)
        this.FormReceivingProductsAdd.controls.palletsx.setValue(1)
        this.FormReceivingProductsAdd.controls.Serial.setValue('')

        var rr = {}
        rr['ID'] = this.Registro
        this.spinner.show()
        setTimeout(() => {
          this.OnSelectProductsItems()
          this.OnReceivinTebleEdit(rr)
          this.spinner.hide()
        }, 1200)
      })
  }

  OnMultiplicarPalletes(Data: Event) {
    this.piezas =
      Number(this.FormReceivingProductsAdd.controls.palletsx.value) *
      Number(this.FormReceivingProductsAdd.controls.Quantity.value)
  }
  OnSelectCostumer() {
    var json = JSON.parse(localStorage.getItem('currentUser')) //json con datos de usuario

    var Request = {}
    Request['companyId'] = json.companyIdWh
    Request['active'] = '1'

    this._httpClient
      .post<any>(`${environment.apiUrl}/Shipping/PlaceOrderCustomer`, Request, {
        headers: new HttpHeaders({
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Headers': '*',
          'Access-Control-Allow-Methods': '*',
          Authorization: 'Bearer ' + json.token
        })
      })
      .subscribe((response: any) => {
        this.PlaceOrderCustomer = response
      })
  }
  OnSelectProductsItems() {
    var Request = {}
    Request['companyId'] = Number(
      this.authenticationService.currentUserValue.companyIdWh
    )
    Request['customerId'] = Number(
      this.FormReceivingProducts.controls.customer.value
    )
    this._httpClient
      .post<any>(
        `${environment.apiUrl}/Receive/ReceivingProdutsItems`,
        Request,
        {
          headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'Access-Control-Allow-Methods': '*',
            Authorization:
              'Bearer ' + this.authenticationService.currentUserValue.token
          })
        }
      )
      .subscribe((response: ProduuctsSelect[]) => {
        this.myControl.patchValue('', { emitEvent: true })
        this.ArrayProdutsItems = response
        this.options = response
        this.options2 = response
        this.filteredOptions = this.myControl.valueChanges.pipe(
          startWith(''),
          map(value => (typeof value === 'string' ? value : value)),
          map(name => (name ? this._filter(name) : this.options.slice()))
        )
      })
  }
  OnSelectProductsItemsmodal(data: any) {
    console.log(data)
    var Request = {}
    Request['companyId'] = Number(
      this.authenticationService.currentUserValue.companyIdWh
    )
    Request['customerId'] = Number(
      this.FormReceivingProducts.controls.customer.value
    )
    this._httpClient
      .post<any>(
        `${environment.apiUrl}/Receive/ReceivingProdutsItems`,
        Request,
        {
          headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'Access-Control-Allow-Methods': '*',
            Authorization:
              'Bearer ' + this.authenticationService.currentUserValue.token
          })
        }
      )
      .subscribe((response: ProduuctsSelect[]) => {
        this.ArrayProdutsItems = response
        this.options = response
        this.options2 = response
        this.datosinicio = data.Resultado
        this.myControl.patchValue('', { emitEvent: true })
        try {
          document.getElementById('product').click()

          this.filteredOptions = this.myControl.valueChanges.pipe(
            startWith(this.datosinicio || ''),
            map(value => (typeof value === 'string' ? value : value)),
            map(name => (name ? this._filter(name) : this.options.slice()))
          )
        } catch (error) {
          console.log(error)
        }
      })
  }
  OnSelectLocations(search: any) {
    var ss = String(search)

    if (ss == '') {
      this._httpClient
        .get<any>(
          `${
            environment.apiUrl
          }/Administracion/SearchLocationsNew?companyId=${Number(
            this.authenticationService.currentUserValue.companyIdWh
          )}&active=1&search=${String(search)}`,

          {
            headers: new HttpHeaders({
              'Access-Control-Allow-Origin': '*',
              'Access-Control-Allow-Headers': '*',
              'Access-Control-Allow-Methods': '*',
              Authorization:
                'Bearer ' + this.authenticationService.currentUserValue.token
            })
          }
        )
        .subscribe((response: any) => {
          this.ArrayLocations = response
        })
    } else {
      if (ss.length > 3) {
        this._httpClient
          .get<any>(
            `${
              environment.apiUrl
            }/Administracion/SearchLocationsNew?companyId=${Number(
              this.authenticationService.currentUserValue.companyIdWh
            )}&active=1&search=${String(search)}`,

            {
              headers: new HttpHeaders({
                'Access-Control-Allow-Origin': '*',
                'Access-Control-Allow-Headers': '*',
                'Access-Control-Allow-Methods': '*',
                Authorization:
                  'Bearer ' + this.authenticationService.currentUserValue.token
              })
            }
          )
          .subscribe((response: any) => {
            this.ArrayLocations = response
            this.locationsSelect.open()
          })
      } else {
      }
    }
  }
  OnConfirmar(data: any) {
    console.log(data)
    this.ConfirmDatabase = new ViewConfirmProductsService(this._httpClient)
    console.log('data')
    //this.inventorySearch=data;
    merge()
      .pipe(
        startWith({}),
        switchMap(() => {
          // this.OnChangeLoader()
          console.log('rrr')
          this.idConfirmClickReferechTable = Number(data.ID)
          this.isLoadingResultsConfirm = true
          this.spinner.show()
          return this.ConfirmDatabase!.getRepoIssues(
            String(data.ID),
            this.authenticationService.currentUserValue.token
          )
        }),
        map(data => {
          // Flip flag to show that loading has finished.
          this.isLoadingResultsConfirm = false
          this.isRateLimitReachedConfirm = false

          this.resultsLengthConfirm = data.length
          return data
        }),
        catchError(() => {
          this.spinner.hide()
          return observableOf([])
        })
      )
      .subscribe(datas => {
        this.dataArrary = datas

        this.dataConfirm = new MatTableDataSource(this.dataArrary)

        try {
          this.dataConfirm.sort = this.sortConfirm
        } catch (error) {}
        try {
          this.dataConfirm.paginator = this.paginatorConfirm
        } catch (error) {}

        try {
          for (let index = 0; index < 10; index++) {
            var etiquet = 'mat-tab-label-' + index + '-1'
            var etiquet2 = 'mat-tab-label-' + index + '-2'
            try {
              document.getElementById(etiquet).style.display = 'block'
              document.getElementById(etiquet2).style.display = 'none'
            } catch (error) {}
          }
          this.spinner.hide()
        } catch (error) {}
        this.confirmarTab = false
        this.viewEdit = true
        this.indexTabs.setValue(1)
      })
    // this.OnChangeSearch()
  }

  OnReceivinTebleEdit(data: any) {
    this.ReceivingEditatableServices = new ReceivingEditTableProductService(
      this._httpClient
    )
    this.idrefesttable = data
    merge()
      .pipe(
        startWith({}),
        switchMap(() => {
          this.spinner.show()
          this.isLoadingResults2 = true
          return this.ReceivingEditatableServices!.getRepoIssuesAdd(
            String(data.ID),
            this.authenticationService.currentUserValue.token
          ).pipe(catchError(() => observableOf(null)))
        }),
        map(data => {
          // Flip flag to show that loading has finished.
          this.isLoadingResults2 = false
          this.spinner.hide()
          this.isRateLimitReached2 = data === null

          if (data === null) {
            return []
          }
          this.viewEdit = true

          return data
        }),
        catchError(() => {
          return observableOf([])
        })
      )
      .subscribe(datas => {
        this.dataArrayReceivingEdit = datas
        try {
          this.resultsLengthProduct = this.dataArrayReceivingEdit.length
        } catch (error) {}
        try {
          console.log(this.dataArrayReceivingEdit.length, 'totalItems')
        } catch (error) {}

        this.dataReceivingEdit = new MatTableDataSource(
          this.dataArrayReceivingEdit
        )
        try {
          this.dataReceivingEdit.sort = this.receivingeditSort
          this.dataReceivingEdit.paginator = this.receivingeditPaginator
        } catch (error) {}
        this.viewproducts = true
      })
  }

  OnChangeInventoryAvailable(data: any) {
    this.InventarioTable = true
    this.InventoryDatabase = new ViewInventotyAvailableService(this._httpClient)
    console.log('data')
    //this.inventorySearch=data;
    merge()
      .pipe(
        startWith({}),
        switchMap(() => {
          this.OnChangeLoader()
          console.log('rrr')
          return this.InventoryDatabase!.getRepoIssues(
            String(data),
            this.authenticationService.currentUserValue.token
          )
        }),
        map(data => {
          // Flip flag to show that loading has finished.

          return data
        }),
        catchError(() => {
          return observableOf([])
        })
      )
      .subscribe(datas => {
        this.dataInventory = datas

        this.dataSource = new MatTableDataSource(this.dataInventory)

        this.dataSource.sort = this.sort
        this.dataSource.paginator = this.paginator
      })
  }
  OnProductEditar(data: ResponseConfirmProductsReceivingAdd) {
    this.openDialogEditAddProduct(data)
  }
  OnProductDelete() {}
  OnCChangeInventoryMove(data: any) {
    this.MoveInventoryTable = true
    this.idmoveInventoryTable = Number(data)
    this.MoveInventory = new ViewReceivingMoveInventoryService(this._httpClient)
    console.log('data')
    //this.inventorySearch=data;
    merge()
      .pipe(
        startWith({}),
        switchMap(() => {
          this.spinner.show()
          // this.OnChangeLoader()
          console.log('rrr')
          return this.MoveInventory!.getRepoIssues(
            String(data),
            this.authenticationService.currentUserValue.token
          )
        }),
        map(data => {
          // Flip flag to show that loading has finished.
          this.spinner.hide()
          return data
        }),
        catchError(() => {
          this.spinner.hide()
          return observableOf([])
        })
      )
      .subscribe(datas => {
        this.dataMoveInventory = datas
        this.spinner.hide()

        this.dataSourceMove = new MatTableDataSource(this.dataMoveInventory)

        this.dataSourceMove.sort = this.sortMove
        this.dataSourceMove.paginator = this.paginatorMove
      })
  }
  filterDataCustomerSearchOrder(locationName: string) {
    return this.PlaceOrderCustomer.filter(object => {
      if (object['value'] == locationName) {
        return object
      }
    })
  }

  OnTeblaViewReceivingProducts(dataTable: any) {
    this.ViewProductTab = false
    try {
      for (let index = 0; index < 10; index++) {
        var etiquet = 'mat-tab-label-' + index + '-1'
        var etiquet2 = 'mat-tab-label-' + index + '-2'
        try {
          document.getElementById(etiquet).style.display = 'none'
          document.getElementById(etiquet2).style.display = 'block'
        } catch (error) {}
      }
    } catch (error) {}
    this.indexTabs = new FormControl(2)
    this.ReceivingServicesViewProducts = new ViewReceivingProductsService(
      this._httpClient
    )

    merge()
      .pipe(
        startWith({}),
        switchMap(() => {
          this.OnChangeLoader()
          return this.ReceivingServicesViewProducts!.getRepoIssues(
            String(dataTable.ID),
            this.authenticationService.currentUserValue.token
          )
        }),
        map(data => {
          return data
        }),
        catchError(() => {
          return observableOf([])
        })
      )
      .subscribe(datas => {
        this.dataArrayServicesViewProducts = datas

        this.dataServicesViewProducts = new MatTableDataSource(
          this.dataArrayServicesViewProducts
        )

        this.dataServicesViewProducts.paginator =
          this.TableViewReceivingProductsPaginator
        this.dataServicesViewProducts.sort = this.TableViewReceivingProductsSort
      })
  }
  OnCancelTabas() {
    try {
      for (let index = 0; index < 10; index++) {
        var etiquet = 'mat-tab-label-' + index + '-1'
        var etiquet2 = 'mat-tab-label-' + index + '-2'
        try {
          document.getElementById(etiquet).style.display = 'none'
          document.getElementById(etiquet2).style.display = 'none'
        } catch (error) {}
      }
    } catch (error) {}
    this.confirmarTab = true
    this.ViewProductTab = true
    this.idConfirmClickReferechTable = 0
    this.indexTabs = new FormControl(3)
  }
  openDialog(datos: ResponseConfirmProductsReceivingConfin): void {
    const dialogRef = this.dialog.open(ConfirmProductReceivingComponent, {
      width: '460px',
      data: datos
    })

    dialogRef.afterClosed().subscribe(result => {
      var tt = {}
      tt['ID'] = this.idConfirmClickReferechTable
      this.OnConfirmar(tt)
    })
  }
  OnDeleteProductSearch(Datos: any) {
    console.log(Datos)
    var Request = {}
    Request['id'] = Number(Datos.ID)

    this._httpClient
      .post<any>(
        `${environment.apiUrl}/Receive/DeleteReceivingSearch`,
        Request,
        {
          headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'Access-Control-Allow-Methods': '*',
            Authorization:
              'Bearer ' + this.authenticationService.currentUserValue.token
          })
        }
      )
      .subscribe((response: any) => {
        Swal.fire({
          icon: 'info',
          title: 'Delete',
          text: response.responses
        })
        this.OnChangeSearch()
      })
  }
  onRemoveInventory(Datos: any) {
    console.log(Datos,'onRemoveInventory')
    var Request = {}
    Request['id'] = Number(Datos.ID)

     this._httpClient
      .post<any>(
        `${environment.apiUrl}/Receive/removeInventoryReceiving`,
        Request,
        {
          headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'Access-Control-Allow-Methods': '*',
            Authorization:
              'Bearer ' + this.authenticationService.currentUserValue.token
          })
        }
      )
      .subscribe((response: any) => {
        Swal.fire({
          icon: 'info',
          title: 'Delete',
          text: response.responses
        })
        this.OnChangeSearch()
        
      }) 
  }
  OnDeleteViewProdts(Datos: any) {
    var Request = {}
    Request['id'] = Number(Datos.id)

    this._httpClient
      .post<any>(
        `${environment.apiUrl}/Receive/DeleteItemsConfirmacionReceiving`,
        Request,
        {
          headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'Access-Control-Allow-Methods': '*',
            Authorization:
              'Bearer ' + this.authenticationService.currentUserValue.token
          })
        }
      )
      .subscribe((response: any) => {
        Swal.fire({
          icon: 'info',
          title: 'Delete',
          text: response.responses
        })
      })
  }
  OnDeleteConfirmProductSearch(datos: ResponseConfirmProductsReceivingConfin) {
    console.log(datos)
    var Request = {}
    Request['id'] = Number(datos.Id)

    this._httpClient
      .post<any>(
        `${environment.apiUrl}/Receive/DeleteItemsConfirmacionReceiving`,
        Request,
        {
          headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'Access-Control-Allow-Methods': '*',
            Authorization:
              'Bearer ' + this.authenticationService.currentUserValue.token
          })
        }
      )
      .subscribe((response: any) => {
        Swal.fire({
          icon: 'info',
          title: 'Delete',
          text: response.responses
        })
      })
  }
  openDialogEditProductsItems(datos: ResponseViewProductsReceiving): void {
    const dialogRef = this.dialog.open(EditProductsItemsComponent, {
      width: '100vh',
      data: datos
    })

    dialogRef.afterClosed().subscribe(result => {
      var tt = {}
      tt['ID'] = datos.tblReceivingProductsID
      this.OnTeblaViewReceivingProducts(tt)
    })
  }

  openDialogEditMoveInventory(datos: ResponseViewInventoryMove): void {
    this._httpClient
      .get<any>(
        `${
          environment.apiUrl
        }/Administracion/SearchLocationsNew?companyId=${Number(
          this.authenticationService.currentUserValue.companyIdWh
        )}&active=1&search=${String(datos.Location)}`,

        {
          headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'Access-Control-Allow-Methods': '*',
            Authorization:
              'Bearer ' + this.authenticationService.currentUserValue.token
          })
        }
      )
      .subscribe((response: any) => {
        this.idjsonMoveInventoryLocation = response
        this.datosMove = {
          id: datos.id,
          ItemNumber: datos.ItemNumber,
          Description: datos.Description,
          LotNumber: datos.LotNumber,
          Location: JSON.stringify(this.idjsonMoveInventoryLocation),
          Quantity: datos.Quantity
        }

        const dialogRef = this.dialog.open(UpdateMoveInventoryComponent, {
          width: '100vh',
          data: this.datosMove
        })

        dialogRef.afterClosed().subscribe(result => {
          this.OnCChangeInventoryMove(String(this.idmoveInventoryTable))
        })
      })
  }
  filterDatalocationMoveInventory(locationName: string) {
    return this.ArrayLocations.filter(object => {
      if (object['Location'] == locationName) {
        return object
      }
    })
  }
  ModalProducts(): void {
    this.datosLector = {
      Resultado: '',
      modulo: String(this.FormReceivingProducts.controls.customer.value)
    }
    const dialogRef = this.dialog.open(AddProductsModalComponent, {
      width: '100vf',
      height: '100vf',
      data: this.datosLector
    })

    dialogRef.afterClosed().subscribe(result => {
      if (
        result.Resultado == '' ||
        result.Resultado == null ||
        result.Resultado == undefined
      ) {
        this.OnSelectProductsItems()
        document.getElementById('product').click()
      } else {
        this.OnSelectProductsItemsmodal(result)
      }
    })
  }
  openDialogLector(): void {
    const dialogRef = this.dialog.open(CodeBarScannerComponent, {
      width: '300px',
      data: this.datosLector
    })

    dialogRef.afterClosed().subscribe(result => {
      this.dataSourceSearch.filter = result.Resultado.trim().toLowerCase()

      if (this.dataSourceSearch.paginator) {
        this.dataSourceSearch.paginator.firstPage()
      }
    })
  }
  openDialogEditAddProduct(data: any): void {
    const dialogRef = this.dialog.open(EditProductReceivingComponent, {
      width: '600px',
      data: data
    })

    dialogRef.afterClosed().subscribe(result => {
      this.OnReceivinTebleEdit(this.idrefesttable)
    })
  }
  OpenDialogMasivo(): void {
    const dialogRef = this.dialog.open(MasivoConfimacionReceivingComponent, {
      width: '100vw',
      data: this.selection.selected
    })

    dialogRef.afterClosed().subscribe(result => {
      this.spinner.show()
      setTimeout(() => {
        try {
          this.selection.clear()
        } catch (error) {}
        var tt = {}
        tt['ID'] = this.idConfirmClickReferechTable
        this.OnConfirmar(tt)
        setTimeout(() => {
          this.OnChangeSearch()
        }, 1000)
      }, 1200)
    })
  }
  OnDeleteProductAdd(data: ResponseConfirmProductsReceiving) {
    var Request = {}
    Request['id'] = Number(data.id)

    this._httpClient
      .post<any>(
        `${environment.apiUrl}/Receive/ReceivingProductsDeleteAdd`,
        Request,
        {
          headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'Access-Control-Allow-Methods': '*',
            Authorization:
              'Bearer ' + this.authenticationService.currentUserValue.token
          })
        }
      )
      .subscribe((response: any) => {
        Swal.fire({
          icon: 'info',
          title: 'Delete',
          text: response.responses
        })
        var rr = {}
        rr['ID'] = this.Registro
        this.OnReceivinTebleEdit(rr)
      })
  }
  //FILTRO DE TABLA DE CONFIRMACION DE PRODUCTO
  applyFilterTableConfirmacion(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value
    this.dataConfirm.filter = filterValue.trim().toLowerCase()

    if (this.dataConfirm.paginator) {
      this.dataConfirm.paginator.firstPage()
    }
  }
  //LECTOR DE CODIGO DE BARRAS
  openDialogLectorGeneral(tipo: Number): void {
    const dialogRef = this.dialog.open(CodeBarScannerComponent, {
      width: '300px',
      data: this.datosLector
    })

    dialogRef.afterClosed().subscribe(result => {
      if (tipo == 1) {
        this.dataSourceMove.filter = result.Resultado.trim().toLowerCase()

        if (this.dataSourceMove.paginator) {
          this.dataSourceMove.paginator.firstPage()
        }
      } else if (tipo == 2) {
        this.dataSource.filter = result.Resultado.trim().toLowerCase()

        if (this.dataSource.paginator) {
          this.dataSource.paginator.firstPage()
        }
      } else if (tipo == 3) {
        this.dataServicesViewProducts.filter =
          result.Resultado.trim().toLowerCase()

        if (this.dataServicesViewProducts.paginator) {
          this.dataServicesViewProducts.paginator.firstPage()
        }
      } else if (tipo == 4) {
        this.dataConfirm.filter = result.Resultado.trim().toLowerCase()

        if (this.dataConfirm.paginator) {
          this.dataConfirm.paginator.firstPage()
        }
      } else if (tipo == 5) {
        this.dataReceivingEdit.filter = result.Resultado.trim().toLowerCase()

        if (this.dataReceivingEdit.paginator) {
          this.dataReceivingEdit.paginator.firstPage()
        }
      }
    })
  }

  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    const numSelected = this.selection.selected.length
    const numRows = this.dataConfirm.data.length
    return numSelected === numRows
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    console.log(this.selection)
    this.isAllSelected()
      ? this.selection.clear()
      : this.dataConfirm.data.forEach(row => this.selection.select(row))
  }

  /** The label for the checkbox on the passed row */
  checkboxLabel(row?: ResponseConfirmProductsReceivingConfin): string {
    if (!row) {
      return `${this.isAllSelected() ? 'select' : 'deselect'} all`
    }
    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${
      row.Id + 1
    }`
  }
  OnMAsivoConfimacion(
    datos: ResponseConfirmProductsReceivingConfin,
    evento: Event
  ) {
    return evento.stopPropagation()
  }
  OpenDialogPDFpalletlabel(data: any): void {
    localStorage.setItem('pdf', JSON.stringify(data))
    this._bottomSheet.open(OpcionesComponent)
  }
  @ViewChild('exportExcel') table: ElementRef
  exportAsExcel() {
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(
      this.table.nativeElement
    ) //converts a DOM TABLE element to a worksheet
    const wb: XLSX.WorkBook = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1')

    /* save to file */
    XLSX.writeFile(wb, 'SheetJS.xlsx')
  }
  OnChangeReceivingTable(data: any) {
    var Rquest = {}
    Rquest['id'] = Number(data)
    this._httpClient
      .post<any>(
        `${environment.apiUrl}/Administracion/ReceivingChangeSearch`,
        Rquest,
        {
          headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'Access-Control-Allow-Methods': '*',
            Authorization:
              'Bearer ' + this.authenticationService.currentUserValue.token
          })
        }
      )
      .subscribe((response: ResponseReceivingChanges[]) => {
        this.arrayDatosChangeReceivinng = response
        this.dataSourceChangesReceivig = new MatTableDataSource(
          this.arrayDatosChangeReceivinng
        )
        try {
          this.dataSourceChangesReceivig.sort = this.ChangeReceivinngsortSearch
          this.dataSourceChangesReceivig.paginator =
            this.ChangeReceivinngpaginatorSearch
        } catch (error) {}
      })
  }
  OnChangeInvoiceList() {
    var Rquest = {}
    Rquest['companyId'] = Number(
      this.authenticationService.currentUserValue.companyIdWh
    )
    Rquest['active'] = 1
    this._httpClient
      .post<any>(
        `${environment.apiUrl}/Administracion/ReceivingInvoicelistSelect`,
        Rquest,
        {
          headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'Access-Control-Allow-Methods': '*',
            Authorization:
              'Bearer ' + this.authenticationService.currentUserValue.token
          })
        }
      )
      .subscribe((response: any) => {
        this.invoiceList = response
      })
  }

  OnEditNewChanges(data: ResponseReceivingChanges) {
    this.IdEditNewChanges = data.Id
    this.FormReceivingChanges.controls.priceUnit.setValue(data.UnitPrice)
    this.FormReceivingChanges.controls.QuantityChanges.setValue(data.Quantity)
    this.FormReceivingChanges.controls.TotalChangesR.setValue(data.Total)
    //this.FormReceivingChanges.controls.QBIntegrated.setValue(data.QBIntegrated)
    var jj = this.filterDatainvoiceList(data.tblInvoiceListDescription)
    console.log(jj)
    this.FormReceivingChanges.controls.invoiceListSelect.setValue(jj[0])
    this.OnCustomerChargesDescS(jj[0].key)
  }
  filterDatainvoiceList(locationName: string) {
    return this.invoiceList.filter(object => {
      if (object['value'] == locationName) {
        return object
      }
    })
  }
  OnNewChanges() {
    this.selectInvoice =
      this.FormReceivingChanges.controls.invoiceListSelect.value

    var Rquest = {}
    Rquest['tipo'] = Number(this.IdEditNewChanges)
    Rquest['tblReceivingID'] = Number(this.Registro)
    if (
      this.IdChargesDescuento == null ||
      this.IdChargesDescuento == undefined
    ) {
      Rquest['tblCompanyChargesID'] = null
    } else {
      Rquest['tblCompanyChargesID'] = Number(this.IdChargesDescuento)
    }
    Rquest['tblInvoiceListID'] = Number(this.selectInvoice.key)

    Rquest['tblInvoiceListDescription'] = this.selectInvoice.value
    Rquest['ChargeDescription'] = this.selectInvoice.value
    Rquest['UnitPrice'] = String(
      this.FormReceivingChanges.controls.priceUnit.value
    )
    Rquest['Quantity'] = String(
      this.FormReceivingChanges.controls.QuantityChanges.value
    )
    var tt = 0

    try {
      console.log(
        this.FormReceivingChanges.controls.TotalChangesR.value,
        this.descuentoCharges
      )
      tt =
        Number(this.FormReceivingChanges.controls.TotalChangesR.value) -
        Number(this.descuentoCharges)
    } catch (error) {}

    Rquest['Total'] = String(tt)

    Rquest['QBIntegrated'] = 0

    this._httpClient
      .post<any>(
        `${environment.apiUrl}/Administracion/NewReceivingChanges`,
        Rquest,
        {
          headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'Access-Control-Allow-Methods': '*',
            Authorization:
              'Bearer ' + this.authenticationService.currentUserValue.token
          })
        }
      )
      .subscribe((response: any) => {
        this.OnClearReceivingCharges()
        console.log(response)
        this.OnChangeReceivingTable(this.Registro)
      })
  }
  OnChangeReceivingTable2(data: any) {
    console.log(data)
    this._httpClient
      .get<any>(
        `${
          environment.apiUrl
        }/Administracion/InvoiceChangeSearch?id_order=${Number(
          data
        )}&type_order=RECEIVE-GENERAL`,

        {
          headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'Access-Control-Allow-Methods': '*',
            Authorization:
              'Bearer ' + this.authenticationService.currentUserValue.token
          })
        }
      )
      .subscribe((response: any) => {
        try {
          if (response.length > 0) {
            this.arrayDatosChangeReceivinng2 = []
            for (let index = 0; index < response.length; index++) {
              const element = response[index]
              this.arrayDatosChangeReceivinng2.push(element)
            }
          }
        } catch (error) {}
      })
  }
  OnDeleteChanges(data: ResponseReceivingChanges) {
    var Rquest = {}
    Rquest['id'] = Number(data.Id)

    this._httpClient
      .post<any>(
        `${environment.apiUrl}/Administracion/DeleteReceivingChanges`,
        Rquest,
        {
          headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'Access-Control-Allow-Methods': '*',
            Authorization:
              'Bearer ' + this.authenticationService.currentUserValue.token
          })
        }
      )
      .subscribe((response: any) => {
        console.log(response)
        this.OnChangeReceivingTable(this.Registro)
      })
  }

  OnCustomerChargesDesc(data: any) {
    console.log(data)
    var Rquest = {}
    Rquest['company'] = Number(
      this.authenticationService.currentUserValue.companyIdWh
    )
    Rquest['customer'] = Number(
      this.FormReceivingProducts.controls.customer.value
    )
    Rquest['invoice'] = Number(data.value.key)
    this._httpClient
      .post<any>(
        `${environment.apiUrl}/Administracion/CustomerChargesSearchDescuento`,
        Rquest,
        {
          headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'Access-Control-Allow-Methods': '*',
            Authorization:
              'Bearer ' + this.authenticationService.currentUserValue.token
          })
        }
      )
      .subscribe((response: any) => {
        try {
          this.IdChargesDescuento = Number(response[0].ChargesId)
          this.descuentoCharges = Number(response[0].total)
        } catch (error) {
          this.IdChargesDescuento = null
          this.descuentoCharges = 0
        }
      })
  }
  OnClearReceivingCharges() {
    this.IdEditNewChanges = 0
    this.descuentoCharges = 0
    this.FormReceivingChanges.controls.priceUnit.setValue(null)
    this.FormReceivingChanges.controls.QuantityChanges.setValue(null)
    this.FormReceivingChanges.controls.TotalChangesR.setValue(null)
    //this.FormReceivingChanges.controls.QBIntegrated.setValue(null)

    this.FormReceivingChanges.controls.invoiceListSelect.setValue(null)
  }
  OnCustomerChargesDescS(data: any) {
    console.log(data)
    var Rquest = {}
    Rquest['company'] = Number(
      this.authenticationService.currentUserValue.companyIdWh
    )
    Rquest['customer'] = Number(
      this.FormReceivingProducts.controls.customer.value
    )
    Rquest['invoice'] = Number(data)
    this._httpClient
      .post<any>(
        `${environment.apiUrl}/Administracion/CustomerChargesSearchDescuento`,
        Rquest,
        {
          headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'Access-Control-Allow-Methods': '*',
            Authorization:
              'Bearer ' + this.authenticationService.currentUserValue.token
          })
        }
      )
      .subscribe((response: any) => {
        try {
          this.IdChargesDescuento = Number(response[0].ChargesId)
          this.descuentoCharges = Number(response[0].total)
        } catch (error) {
          this.IdChargesDescuento = null
          this.descuentoCharges = 0
        }
      })
  }
  onCheckAllCharges(data: any) {
    console.log(data.checked)
    this.OnChangeLoader()
    var Request = {}
    if (this.buttonEdita) {
      Request['tipo'] = Number(this.IdEditar)
    } else {
      Request['tipo'] = 0
    }

    Request['tblCompanyID'] = String(
      this.authenticationService.currentUserValue.companyIdWh
    )
    Request['tblCustomerID'] = String(
      this.FormReceivingProducts.controls.customer.value
    )
    Request['ReferenceNumber'] = String(
      this.FormReceivingProducts.controls.referencia.value || ' '
    )
    Request['ETA'] = this.FormReceivingProducts.controls.eta.value
    Request['ReceivedDate'] =
      this.FormReceivingProducts.controls.receivingdate.value
    Request['CarrierName'] = String(
      this.FormReceivingProducts.controls.Carrier.value
    )
    Request['BOLNumber'] = String(this.FormReceivingProducts.controls.bol.value)
    Request['PONumber'] = String(this.FormReceivingProducts.controls.po.value)
    Request['ContainerNumber'] = String(
      this.FormReceivingProducts.controls.container.value
    )
    Request['SealNumber'] = String(
      this.FormReceivingProducts.controls.seal.value
    )
    Request['MiscText'] = String(this.FormReceivingProducts.controls.misc.value)
    Request['CapacityType'] = String(
      this.FormReceivingProducts.controls.capacity.value
    )
    Request['DoorNumber'] = String(
      this.FormReceivingProducts.controls.door.value
    )
    Request['Notes'] = String(this.FormReceivingProducts.controls.notes.value)
    Request['Completed'] = '0'
    Request['CompletedDate'] = ''
    Request['DateCreated'] = new Date()
    Request['TotalPallets'] = String(
      this.FormReceivingProducts.controls.pallets.value || '0'
    )

    Request['Users'] = String(
      this.authenticationService.currentUserValue.useremail
    )

    Request['Billed'] = Number(this.FormReceivingProducts.controls.Billed.value)
    //this.FormReceivingProducts.controls.AllChargesAdded.value
    Request['AllChargesAdded'] = Number(data.checked)
    Request['HandlingCharge'] = Number(
      this.FormReceivingProducts.controls.HandlingCharge.value
    )
    Request['ShortTermStorage'] = Number(
      this.FormReceivingProducts.controls.ShortTermStorage.value
    )

    var json = JSON.parse(localStorage.getItem('currentUser')) //json con datos de usuario

    this._httpClient
      .post<any>(
        `${environment.apiUrl}/Receive/ReceivingProductsNewEdit`,
        Request,
        {
          headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'Access-Control-Allow-Methods': '*',
            Authorization: 'Bearer ' + json.token
          })
        }
      )
      .subscribe((response: any) => {
        this.Registro = response.responses
        try {
          var ids = String(this.Registro)
          var rep = ids
            .replace('receiving-new-', '')
            .replace('receiving-edit-', '')
          this.Registro = Number(rep)
          this.productosTab = false
          this.productosChangeTab = false
          this.viewEdit = true
          this.tab1 = false

          this.OnSelectProductsItems()
          this.OnChangeReceivingTable(this.Registro)
          Swal.fire({
            icon: 'info',
            title: 'Receiving',
            text: 'Success'
          })
        } catch (error) {
          this.Toast.fire({
            icon: 'error',
            title: 'Error'
          })
        }
      })
  }

  OnOperacion() {
    this.FormReceivingChanges.controls.TotalChangesR.setValue(
      Number(this.FormReceivingChanges.controls.priceUnit.value) *
        Number(this.FormReceivingChanges.controls.QuantityChanges.value)
    )
  }
  makeid(length) {
    var result = ''
    var characters =
      'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
    var charactersLength = characters.length
    for (var i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength))
    }
    return result
  }
  openDialogPalletEdit(datosEdi: any): void {
    const dialogRef = this.dialog.open(EditPalletCustomersComponent, {
      width: '50vw',
      height: '30vh',
      data: { ID: datosEdi.ID, tblcustomerID: datosEdi.tblcustomerID }
    })

    dialogRef.afterClosed().subscribe(result => {
      this.OnChangeSearch()
    })
  }

  openDialogPalletEdit2(datosEdi: any): void {
    const dialogRef = this.dialog.open(EditPalletCustomersComponent, {
      width: '40vw',

      data: { ID: datosEdi.ID, tblcustomerID: datosEdi.tblcustomerID }
    })

    dialogRef.afterClosed().subscribe(result => {
      this.OnChangeSearch()
    })
  }

  OnChangeTypeAvailable(data: any) {
    console.log(data)
    if (data == 'CTNS') {
      this.ispallet = false
    } else {
      this.ispallet = true
    }
  }

  OnInvoiceHeaderInsert() {
    var Request = {
      tipo: Number(this.FormInvoiceHeader.controls.tipo.value),
      id_order: Number(this.IdEditar),
      type_order: String(this.FormInvoiceHeader.controls.type_order.value),
      fromname: String(this.FormInvoiceHeader.controls.fromname.value),
      fromstreet: String(this.FormInvoiceHeader.controls.fromstreet.value),
      toname: String(this.FormInvoiceHeader.controls.toname.value),
      tostreet: String(this.FormInvoiceHeader.controls.tostreet.value),
      billname: String(this.FormInvoiceHeader.controls.billname.value),
      billstreet: String(this.FormInvoiceHeader.controls.billstreet.value),
      invoicenumber: String(
        this.FormInvoiceHeader.controls.invoicenumber.value
      ),
      payterm: String(this.FormInvoiceHeader.controls.payterm.value),
      customerid: String(this.FormInvoiceHeader.controls.customerid.value),
      referencesnumber: String(
        this.FormInvoiceHeader.controls.referencesnumber.value
      ),
      dateinvoice: this.FormInvoiceHeader.controls.dateinvoice.value || null,
      totalamount: String(this.FormInvoiceHeader.controls.totalamount.value),
      noteinvoice: String(this.FormInvoiceHeader.controls.noteinvoice.value),
      companyID: Number(this.authenticationService.currentUserValue.companyIdWh)
    }

    this._httpClient
      .post<any>(
        `${environment.apiUrl}/Administracion/invoiceheaderisertupdate`,
        Request,
        {
          headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'Access-Control-Allow-Methods': '*',
            Authorization:
              'Bearer ' + this.authenticationService.currentUserValue.token
          })
        }
      )
      .subscribe((response: any) => {
        this.onSelectInvoiceheadr()
      })
  }
  onSelectInvoiceheadr() {
    this._httpClient
      .get<any>(
        `${environment.apiUrl}/Administracion/invoiceheaderSelectData?id_order=${this.IdEditar}&type_order=Receiving`,

        {
          headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'Access-Control-Allow-Methods': '*',
            Authorization:
              'Bearer ' + this.authenticationService.currentUserValue.token
          })
        }
      )
      .subscribe((response: any) => {
        try {
          this.FormInvoiceHeader.controls.tipo.setValue(
            Number(response[0].id_header)
          )
          this.FormInvoiceHeader.controls.type_order.setValue(
            String(response[0].type_order)
          )
          this.FormInvoiceHeader.controls.fromname.setValue(
            String(response[0].fromname)
          )
          this.FormInvoiceHeader.controls.fromstreet.setValue(
            String(response[0].fromstreet)
          )
          this.FormInvoiceHeader.controls.toname.setValue(
            String(response[0].toname)
          )
          this.FormInvoiceHeader.controls.tostreet.setValue(
            String(response[0].tostreet)
          )
          this.FormInvoiceHeader.controls.billname.setValue(
            String(response[0].billname)
          )
          this.FormInvoiceHeader.controls.billstreet.setValue(
            String(response[0].billstreet)
          )

          this.FormInvoiceHeader.controls.invoicenumber.setValue(
            String(response[0].invoicenumber)
          )
          this.FormInvoiceHeader.controls.payterm.setValue(
            String(response[0].payterm)
          )
          this.FormInvoiceHeader.controls.customerid.setValue(
            String(response[0].customerid)
          )
          this.FormInvoiceHeader.controls.referencesnumber.setValue(
            String(response[0].referencesnumber)
          )

          try {
            this.FormInvoiceHeader.controls.dateinvoice.setValue(
              response[0].dateinvoice
            )
          } catch (error) {}

          this.FormInvoiceHeader.controls.totalamount.setValue(
            String(response[0].totalamount)
          )
          this.FormInvoiceHeader.controls.noteinvoice.setValue(
            String(response[0].noteinvoice)
          )
          this.labelInvoiceHeaderButton = 'Update'
        } catch (error) {
          if (this.FormReceivingProducts.controls.customer.value == 1264) {
            this.FormInvoiceHeader.controls.fromname.setValue(
              String('LINE DRIVE TRUCKING, INC.')
            )
            this.FormInvoiceHeader.controls.fromstreet.setValue(
              String('1231 N MILLER STREET, STE #150 ANAHEIM, CA 93021')
            )
            this.FormInvoiceHeader.controls.toname.setValue(
              String('LINE DRIVE TRUCKING, INC.')
            )
            this.FormInvoiceHeader.controls.tostreet.setValue(
              String('5942 EDIGER AVE. STE #113 HUNTINGTON BEACH, CA 92649.')
            )
            this.FormInvoiceHeader.controls.billname.setValue(
              String('PENTAIR WATER POOL & SPA')
            )
            this.FormInvoiceHeader.controls.billstreet.setValue(
              String('10951 W LOS ANGELES AVE MOORPARK CA 93021')
            )
          } else if (
            this.FormReceivingProducts.controls.customer.value == 1265
          ) {
            this.FormInvoiceHeader.controls.fromname.setValue(
              String('LINE DRIVE TRUCKING, INC.')
            )
            this.FormInvoiceHeader.controls.fromstreet.setValue(
              String('1231 N MILLER STREET, STE #150 ANAHEIM, CA 93021')
            )
            this.FormInvoiceHeader.controls.toname.setValue(
              String('LINE DRIVE TRUCKING, INC.')
            )
            this.FormInvoiceHeader.controls.tostreet.setValue(
              String('5942 EDIGER AVE. STE #113 HUNTINGTON BEACH, CA 92649.')
            )
            this.FormInvoiceHeader.controls.billname.setValue(
              String('PENTAIR WATER POOL & SPA')
            )
            this.FormInvoiceHeader.controls.billstreet.setValue(
              String('13950 MOUNTAIN AVENUE CHINO, CA 91710')
            )
          } else if (
            this.FormReceivingProducts.controls.customer.value == 355
          ) {
            this.FormInvoiceHeader.controls.fromname.setValue(
              String('LINE DRIVE TRUCKING, INC.')
            )
            this.FormInvoiceHeader.controls.fromstreet.setValue(
              String('1231 N MILLER STREET, STE #150 ANAHEIM, CA 93021')
            )
            this.FormInvoiceHeader.controls.toname.setValue(
              String('LINE DRIVE TRUCKING, INC.')
            )
            this.FormInvoiceHeader.controls.tostreet.setValue(
              String('5942 EDIGER AVE. STE #113 HUNTINGTON BEACH, CA 92649.')
            )
            this.FormInvoiceHeader.controls.billname.setValue(String(''))
            this.FormInvoiceHeader.controls.billstreet.setValue(String(''))
          } else if (
            this.FormReceivingProducts.controls.customer.value == 1169
          ) {
            this.FormInvoiceHeader.controls.fromname.setValue(
              String('LINE DRIVE TRUCKING, INC.')
            )
            this.FormInvoiceHeader.controls.fromstreet.setValue(
              String('1231 N MILLER STREET, STE #150 ANAHEIM, CA 93021')
            )
            this.FormInvoiceHeader.controls.toname.setValue(
              String('LINE DRIVE TRUCKING, INC.')
            )
            this.FormInvoiceHeader.controls.tostreet.setValue(
              String('5942 EDIGER AVE. STE #113 HUNTINGTON BEACH, CA 92649.')
            )
            this.FormInvoiceHeader.controls.billname.setValue(
              String('BIN CELLAR USA')
            )
            this.FormInvoiceHeader.controls.billstreet.setValue(
              String('696 SAN RAMON VALLEY BLVD STE 345 DANVILLE, CA 94526')
            )
          } else if (
            this.FormReceivingProducts.controls.customer.value == 1190
          ) {
            this.FormInvoiceHeader.controls.fromname.setValue(
              String('LINE DRIVE TRUCKING, INC.')
            )
            this.FormInvoiceHeader.controls.fromstreet.setValue(
              String('1231 N MILLER STREET, STE #150 ANAHEIM, CA 93021')
            )
            this.FormInvoiceHeader.controls.toname.setValue(
              String('LINE DRIVE TRUCKING, INC.')
            )
            this.FormInvoiceHeader.controls.tostreet.setValue(
              String('5942 EDIGER AVE. STE #113 HUNTINGTON BEACH, CA 92649.')
            )
            this.FormInvoiceHeader.controls.billname.setValue(
              String('COMPLETE SOLAR')
            )
            this.FormInvoiceHeader.controls.billstreet.setValue(String(''))
          } else if (
            this.FormReceivingProducts.controls.customer.value == 379
          ) {
            this.FormInvoiceHeader.controls.fromname.setValue(
              String('LINE DRIVE TRUCKING, INC.')
            )
            this.FormInvoiceHeader.controls.fromstreet.setValue(
              String('1231 N MILLER STREET, STE #150 ANAHEIM, CA 93021')
            )
            this.FormInvoiceHeader.controls.toname.setValue(
              String('LINE DRIVE TRUCKING, INC.')
            )
            this.FormInvoiceHeader.controls.tostreet.setValue(
              String('5942 EDIGER AVE. STE #113 HUNTINGTON BEACH, CA 92649.')
            )
            this.FormInvoiceHeader.controls.billname.setValue(
              String('KINGFA USA')
            )
            this.FormInvoiceHeader.controls.billstreet.setValue(
              String('47440 MICHIGAN AVE, STE 100 CANTON, MI48188')
            )
          } else if (
            this.FormReceivingProducts.controls.customer.value == 1266
          ) {
            this.FormInvoiceHeader.controls.fromname.setValue(
              String('LINE DRIVE TRUCKING, INC.')
            )
            this.FormInvoiceHeader.controls.fromstreet.setValue(
              String('1231 N MILLER STREET, STE #150 ANAHEIM, CA 93021')
            )
            this.FormInvoiceHeader.controls.toname.setValue(
              String('LINE DRIVE TRUCKING, INC.')
            )
            this.FormInvoiceHeader.controls.tostreet.setValue(
              String('5942 EDIGER AVE. STE #113 HUNTINGTON BEACH, CA 92649.')
            )
            this.FormInvoiceHeader.controls.billname.setValue(String(''))
            this.FormInvoiceHeader.controls.billstreet.setValue(String(''))
          } else {
          }

          this.FormInvoiceHeader.controls.tipo.setValue(Number('0'))
          this.FormInvoiceHeader.controls.type_order.setValue(
            String('Receiving')
          )

          this.labelInvoiceHeaderButton = 'Save'
        }
      })
  }
  openExportDataToShipping(datos: ResponseReceivingTableNew): void {
    if (datos.Completed) {
      var re = datos.ReferenceNumber
      console.log(datos)
      if (re == '' || re == ' ') {
        re = datos.ContainerNumber
      }
      const dialogRef = this.dialog.open(
        ReceivingExportProdutsToShippingComponent,
        {
          width: '80vw',
          height: '80vh',
          data: {
            idorder: Number(datos.ID),
            po: String(datos.PONumber || ' '),
            references: String(re || ' '),
            customerId: Number(datos.tblcustomerID)
          }
        }
      )

      dialogRef.afterClosed().subscribe(result => {})
    } else {
      alert('The products are not yet confirmed')
    }
  }

  onSelectSummaryProducts() {
    this._httpClient
      .get<any>(
        `${environment.apiUrl}/Administracion/ReceivingProductsItemsByPalletselectsummary?tblreceivingproductsid=${this.Registro}`,

        {
          headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'Access-Control-Allow-Methods': '*',
            Authorization:
              'Bearer ' + this.authenticationService.currentUserValue.token
          })
        }
      )
      .subscribe((response: any) => {
        this.summaryProducts = []
        this.summaryProducts = response
      })
  }
  applyFilterLocation(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value

    this.OnSelectLocations(filterValue.trim().toLowerCase())
  }
  onAddProductToReceiving(data: any) {
    var Request = {}
    Request['tipo'] = 0
    Request['tblReceivingProductsID'] = Number(this.Registro)
    Request['tblProductID'] = Number(data.id)
    Request['LotNumber'] = ''
    Request['StatedQuantity'] = String(data.quantity || '1')
    Request['ActualQuantity'] = '0'
    Request['Discrepancy'] = '0'
    Request['AvailableQuantity'] = '0'
    Request['tblLocationID'] = String(29276)
    Request['ExpirationDate'] = 'sin'
    Request['Notes'] = ''
    Request['SerialNumber'] = String('')
    Request['Completed'] = 0
    Request['pallex'] = String(data.pallet || '1')
    Request['CompletedDate'] = new Date()
    var typl = ''
    if (String(data.type).includes('PLT')) {
      typl = 'PLTS'
    } else {
      typl = 'CTNS'
    }
    Request['typePallets'] = String(typl || 'PLTS')
    Request['weightPallets'] = Number(0)

    this._httpClient
      .post<any>(
        `${environment.apiUrl}/Receive/ReceivingProdutsItemsNewEditadditional`,
        Request,
        {
          headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'Access-Control-Allow-Methods': '*',
            Authorization:
              'Bearer ' + this.authenticationService.currentUserValue.token
          })
        }
      )
      .subscribe((response: any) => {
        console.log(response, 'ReceivingProdutsItemsNewEditadditional')
      })
  }

  ///import products items to receiving
  public files2: NgxFileDropEntry[] = []

  public dropped2(files: NgxFileDropEntry[]) {
    this.files2 = files
    for (const droppedFile of files) {
      // Is it a file?
      if (droppedFile.fileEntry.isFile) {
        const fileEntry = droppedFile.fileEntry as FileSystemFileEntry
        fileEntry.file((file: File) => {
          // Here you can access the real file
          console.log(droppedFile.relativePath, file)
          let workBook = null
          let jsonData = null
          var reader = new FileReader()

          reader.onload = event => {
            const data = reader.result
            workBook = XLSX.read(data, { type: 'binary' })
            jsonData = workBook.SheetNames.reduce((initial, name) => {
              const sheet = workBook.Sheets[name]
              initial[name] = XLSX.utils.sheet_to_json(sheet)
              return initial
            }, {})

            for (let index = 0; index < jsonData.Sheet1.length; index++) {
              setTimeout(() => {
                try {
                  this.DatosProductsAdd = {
                    tipo: 0,
                    tblCompanyID: Number(
                      this.authenticationService.currentUserValue.companyIdWh
                    ),
                    tblCustomerID: Number(
                      this.FormReceivingProducts.controls.customer.value
                    ),
                    itemNumber: String(jsonData.Sheet1[index].itemNumber || ''),
                    itemDescription: String(
                      jsonData.Sheet1[index].itemDescription || ''
                    ),
                    itemDescription1: String(''),
                    masterBarcode: String(this.makeid(10)),
                    boxBarcode: String(this.makeid(10)),
                    itemBarcode: String(this.makeid(10)),
                    boxDimsHeight: String(1),
                    boxDimsWidth: String(1),
                    boxDimsLength: String(1),
                    boxWeight: String(1),
                    unitMeasureType: Number(0),
                    numberInMaster: Number(1),
                    numberInInner: Number(1),
                    minReorder: Number(1),
                    itemValue: String(1),
                    serialNo: String(0),
                    lotNumber: String(0),
                    palletAmount: Number(1),
                    active: Boolean(true),
                    warehouseStation: '',
                    productImage: '',
                    StackablePallet: String(0)
                  }

                  this._httpClient
                    .post<any>(
                      `${environment.apiUrl}/Products/ProductsInsert`,
                      this.DatosProductsAdd,
                      {
                        headers: new HttpHeaders({
                          'Access-Control-Allow-Origin': '*',
                          'Access-Control-Allow-Headers': '*',
                          'Access-Control-Allow-Methods': '*',
                          Authorization:
                            'Bearer ' +
                            this.authenticationService.currentUserValue.token
                        })
                      }
                    )
                    .subscribe((response: any) => {
                      console.log(response.responses, 'insert')
                      try {
                        var res = String(response.responses)
                        var id = ''
                        try {
                          if (res.includes('success-update:')) {
                            id = res.replace('success-update:', '')
                          } else if (
                            res.includes('there is a record of Item Number:')
                          ) {
                            id = res.replace(
                              'there is a record of Item Number:',
                              ''
                            )
                          } else if (res.includes('success:')) {
                            id = res.replace('success:', '')
                          }
                        } catch (error) {}

                        try {
                          if (id !== '') {
                            var jsonObj = {
                              id: '',
                              pallet: '',
                              quantity: '',
                              type: ''
                            }
                            try {
                              jsonObj['id'] = id.replace(' ', '')
                              jsonObj['pallet'] = String(
                                jsonData.Sheet1[index].pallet
                              ).replace(' ', '')
                              jsonObj['quantity'] = String(
                                jsonData.Sheet1[index].quantity
                              ).replace(' ', '')
                              jsonObj['type'] = String(
                                jsonData.Sheet1[index].type
                              ).replace(' ', '')
                            } catch (error) {
                              console.log(error, 'error')
                            }
                            this.onAddProductToReceiving(jsonObj)
                          }
                        } catch (error) {}

                        // this.datosArrayExcel = {if
                        //   celda: String(index),
                        //   itemname: String(jsonData.Hoja1[index].itemNumber||''),
                        //   mensajes: res,
                        // };

                        // this.arrayMensajesMasivoExcel.push(this.datosArrayExcel);
                      } catch (error) {}
                    })
                } catch (error) {}
              }, 300)
            }

            //this.viewRegistrosMasivos=true;
            var rr = {}
            rr['ID'] = this.Registro
            this.spinner.show()
            setTimeout(() => {
              this.OnSelectProductsItems()
              this.OnReceivinTebleEdit(rr)
              this.spinner.hide()
            }, 1200)
          }

          reader.readAsBinaryString(file)
        })
      } else {
      }
    }
  }

  public fileOver2(event) {
    console.log(event)
  }

  public fileLeave2(event) {
    console.log(event)
  }

}
